import React, { useEffect } from 'react';

/**
 * Component to handle global keyboard shortcuts
 * 
 * Shortcuts implemented:
 * - / : Focus text input
 * - Ctrl + Space: Voice input/mic button
 * - Ctrl + L: Open Canvas List
 * - Ctrl + ,: Open Settings
 * - ↑, ↓: Navigate canvases
 * - Esc: Close panels
 * - Ctrl + H: Open Messages
 */
const KeyboardShortcuts = ({ 
  onFocusInput, 
  onToggleMic, 
  onToggleCanvasList, 
  onOpenSettings,
  onPrevCanvas,
  onNextCanvas,
  onClosePanels,
  onOpenChatHistory
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Focus input with '/'
      if (e.key === '/' && !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        e.preventDefault();
        onFocusInput?.();
      }

      // Ctrl + Space for voice input
      if (e.ctrlKey && e.code === 'Space') {
        e.preventDefault();
        onToggleMic?.();
      }

      // Ctrl + L for Canvas List
      if (e.ctrlKey && e.key === 'l') {
        e.preventDefault();
        onToggleCanvasList?.();
      }

      // Ctrl + , for Settings
      if (e.ctrlKey && e.key === ',') {
        e.preventDefault();
        onOpenSettings?.();
      }

      // Left arrow for previous canvas
      if (e.key === 'ArrowLeft' && !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        e.preventDefault();
        onPrevCanvas?.();
      }

      // Right arrow for next canvas
      if (e.key === 'ArrowRight' && !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        e.preventDefault();
        onNextCanvas?.();
      }

      // Esc to close panels
      if (e.key === 'Escape') {
        e.preventDefault();
        onClosePanels?.();
      }

      // Ctrl + H for Messages
      if (e.ctrlKey && e.key === 'h') {
        e.preventDefault();
        onOpenChatHistory?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    onFocusInput, 
    onToggleMic, 
    onToggleCanvasList, 
    onOpenSettings, 
    onPrevCanvas, 
    onNextCanvas, 
    onClosePanels,
    onOpenChatHistory
  ]);

  // This component doesn't render anything
  return null;
};

export default KeyboardShortcuts;
